import React, { Component } from "react";
import { Spin } from "antd";
import { WhiteSpace } from "peak-design";
import Cookies from "universal-cookie";
import axios from "axios";
import ResizeAware from "react-resize-aware";
import styles from "./styles/client.module.scss";

//components
import { PageTitle } from "../../components/common";
import { ClientCreateForm } from "../../components/forms";

const API_URL = process.env.REACT_APP_API_URL;

class Client extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      receivedMessage: false
    };
  }
  componentDidMount() {
    const cookies = new Cookies();
    const clientId = cookies.get("fasttrek-client");
    // console.log(window.parent.document.getElementById("user-email"));
    window.addEventListener("message", this.receiveMessage);

    // if (clientId) this.props.history.push("/search/existing");
  }
  receiveMessage = event => {
    const data = event.data;
    if (data && !this.state.receivedMessage) {
      axios
        .post(`${API_URL}/client`, data)
        .then(res => {
          const cookies = new Cookies();
          cookies.set("fasttrek-client", res.data.client._id);
          this.setState({ loading: false, receivedMessage: true });
          if (res.data.existing) this.props.history.push("/search/existing");
          else this.props.history.push("/search/new");
        })
        .catch(err => {
          this.setState({ loading: false });
          console.log(err);
        });
    }
  };
  handleResize = ({ width, height }) => {
    window.parent.postMessage(height, "*");
  };
  handleSubmit = (e, form) => {
    e.preventDefault();
    this.setState({ loading: true });
    form.validateFields((err, values) => {
      if (!err) {
        axios
          .post(`${API_URL}/client`, values)
          .then(res => {
            const cookies = new Cookies();
            cookies.set("fasttrek-client", res.data._id);
            this.setState({ loading: false });
            this.props.history.push("/search/new");
          })
          .catch(err => {
            this.setState({ loading: false });
            console.log(err);
          });
      }
    });
  };
  render() {
    const { loading } = this.state;
    return (
      <ResizeAware onResize={this.handleResize} onlyEvent>
        <div className={styles.container} style={{ minHeight: 700 }}>
          {loading ? (
            <div className={styles.loadingContainer}>
              <Spin size="large" tip="Loading..." />
            </div>
          ) : (
            <div>Something went wrong...</div>
          )}
          {/* <div className={styles.containerCentered}>
            <div className={styles.searchContainer}>
              <div className={styles.formContainer}>
                <PageTitle title="Get started by entering your info" />
                <WhiteSpace height={20} />
                <ClientCreateForm
                  handleSubmit={(e, form) => this.handleSubmit(e, form)}
                  loading={loading}
                />
              </div>
            </div>
          </div> */}
        </div>
      </ResizeAware>
    );
  }
}

export { Client };



// WEBPACK FOOTER //
// ./src/containers/pages/Client.js